/**
 * SW update prompt state (registerType: "prompt"): a tiny external store so
 * main.tsx (registerSW's onNeedRefresh) can hand the pending update to React.
 * Reload happens ONLY when the participant taps the banner — never
 * automatically (a mid-quiz reload would burn the one quiz attempt).
 */
import { useSyncExternalStore } from "react";

export interface SwUpdateState {
  needRefresh: boolean;
  /** Applies the waiting SW and reloads (from registerSW's updateSW). */
  apply: (() => void) | null;
}

let state: SwUpdateState = { needRefresh: false, apply: null };
const listeners = new Set<() => void>();

function emit() {
  for (const listener of listeners) listener();
}

/** Called by main.tsx from registerSW({ onNeedRefresh }). */
export function notifySwUpdateReady(apply: () => void): void {
  state = { needRefresh: true, apply };
  emit();
}

/** Test helper / dismiss. */
export function resetSwUpdate(): void {
  state = { needRefresh: false, apply: null };
  emit();
}

export function useSwUpdate(): SwUpdateState {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => state,
    () => state,
  );
}
